function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#F1F2F3;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M153.2,186.1"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M278,142.7L145.3,10c-0.7-0.7-1.9-0.7-2.6,0L10,142.7c-0.7,0.7-0.7,1.9,0,2.6L142.7,278c0.7,0.7,1.9,0.7,2.6,0 L278,145.3C278.7,144.6,278.7,143.4,278,142.7z M141.3,215.8c-8.6,0-15.5-6.9-15.5-15.5c0-8.6,6.9-15.7,15.5-15.7 c8.6,0,15.7,7,15.7,15.7C157.1,208.9,150,215.8,141.3,215.8z M170.2,146l-8,5.7c-6.9,4.9-9.8,10.5-10.6,19c-0.1,0.6-0.7,1.8-1,2.1 c-3.3,4.1-15.4,3.1-19.5-0.3c-1.9-1.7-1.5-5.6-1.5-8.6c0-10.4,4.3-20,15.5-28.5l9.4-7.1c5.9-4.3,8.4-9.6,8.4-15.5 c0-9-6.5-17.6-19.6-17.6c-13.9,0-20,11.2-20,22.2c0,2.3,0.2,5.1-0.9,6.6c-3.7,4.9-18.4,4.7-22-0.2c-1.7-2.3-2-6.9-2-9.9 c0-21.2,15.9-41.6,44.9-41.6c30.4,0,46.3,19.2,46.3,39C189.6,126.8,181.7,137.8,170.2,146z"
});

var SvgHelpReverseIcon = function SvgHelpReverseIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelpReverseIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help-reverse-icon.48d2a343.svg";
export { ForwardRef as ReactComponent };